/* mkv5-pdp.js — JS buy-flow PDP externalisé (P2 perf). Données via window.MK_VP / window.MK_I18N. */

  /*
    CHANGEMENT 1 — le préréglage JS qui forçait le 2e variant (Full Coverage) a été SUPPRIMÉ.
      La PDP ouvre désormais sur Front Only (défaut serveur = selected_or_first_available_variant
      = 1er variant dispo), sans flash du prix ni CLS. ?variant= reste respecté côté serveur.

    CHANGEMENT 2 — Nom du set affiché à côté du prix principal, mis à jour en direct.
      Vanilla JS uniquement, scope main_product. Sur l'event `change` des radios SET
      (input[name$="-option2"]), lit le titre de la carte SET cochée et écrit son nom dans
      [data-mk-price-set-label]. Synchronise aussi .variant-set-card--selected avec la carte cochée.
  */
  (function() {
    if (window.__mkSetLabelInit) return;
    window.__mkSetLabelInit = true;

    // Tapis (car mats) : nom complet avec parenthèse selon le set choisi (aligné sur le rendu serveur price-list)
    var mkIsMat = !!(window.MK_VP && window.MK_VP.isMat);
    function fullSetName(n){
      var k = (n || '').toLowerCase();
      if (k === 'front only') return window.MK_I18N.set_front_only_full;
      if (k === 'full coverage') return window.MK_I18N.set_full_coverage_full;
      if (k === '3-row set') return window.MK_I18N.set_3row_full;
      return n;
    }

    // Persistance du jeu (option2) au changement de couleur : réécrit chaque swatch couleur
    // vers le variant de la couleur-cible ayant le même jeu (fallback = URL produit par défaut).
    function currentCoverage() {
      var checked = document.querySelector('.variant-set-card input[type="radio"][name$="-option2"]:checked');
      if (!checked) return '';
      var card = checked.closest('.variant-set-card');
      var t = card && card.querySelector('.variant-set-card__title');
      return t ? t.textContent.trim() : '';
    }
    function syncSwatchLinks() {
      var cov = currentCoverage();
      var swatches = document.querySelectorAll('.cross-product-swatch');
      for (var i = 0; i < swatches.length; i++) {
        var a = swatches[i];
        var base = a.getAttribute('data-base-href') || a.getAttribute('href');
        if (!base) continue;
        var map = {};
        try { map = JSON.parse(a.getAttribute('data-mkcov') || '{}'); } catch (e) {}
        a.setAttribute('href', (cov && map[cov]) ? map[cov] : base);
      }
    }

    function syncSetLabel() {
      var checked = document.querySelector('.variant-set-card input[type="radio"][name$="-option2"]:checked');
      if (!checked) return;
      var card = checked.closest('.variant-set-card');
      if (!card) return;

      // Garder .variant-set-card--selected en phase avec la carte réellement cochée
      var cards = document.querySelectorAll('.variant-set-card');
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.toggle('variant-set-card--selected', cards[i] === card);
      }

      var titleEl = card.querySelector('.variant-set-card__title');
      var name = titleEl ? titleEl.textContent.trim() : '';
      if (!name) return;

      var labels = document.querySelectorAll('[data-mk-price-set-label]');
      for (var j = 0; j < labels.length; j++) {
        labels[j].textContent = mkIsMat ? fullSetName(name) : name;
      }
    }

    document.addEventListener('change', function(e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[name$="-option2"]')) {
        syncSetLabel();
        syncSwatchLinks();
      }
    });

    // ─── FIX PERSISTANCE COUVERTURE AU SWAP (2026-07-16) ─────────────────────
    // Le `change` ci-dessus synchronise les href AVANT que le variant-picker natif ne
    // re-render la section : le HTML frais du serveur remplace alors les swatches, dont les
    // href reviennent a leur valeur de base -> la couverture etait PERDUE au changement de
    // couleur, pour TOUTES les couleurs (mesure : href OK a t+0, revenus a la base a +600 ms ;
    // temoin Ferrari 3-Row $289 -> swap -> Front Only $149).
    // On resynchronise donc APRES chaque re-render. Meme motif que guaranteeProps
    // (matrikar-vehicle-fit.js), le sticky et le bundle : delegation/observer + debounce.
    // SANS BOUCLE : on n'observe que `childList` — reecrire un attribut href ne declenche
    // aucune mutation childList, donc syncSwatchLinks() ne peut pas se re-declencher lui-meme.
    function resync() { syncSetLabel(); syncSwatchLinks(); }

    var resyncT = null;
    function resyncDebounced() { clearTimeout(resyncT); resyncT = setTimeout(resync, 120); }

    // Le variant-picker natif du theme emet 'variant:change' ; mkv5-pdp emet 'variant:changed'
    // juste apres un swap couleur. Les deux doivent reprovoquer un resync.
    document.addEventListener('variant:change', resyncDebounced);
    document.addEventListener('variant:changed', resyncDebounced);

    function watchMainProduct() {
      try {
        var host = document.querySelector('.shopify-section--main-product');
        if (!host) return;
        new MutationObserver(resyncDebounced).observe(host, { childList: true, subtree: true });
      } catch (e) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ syncSetLabel(); syncSwatchLinks(); watchMainProduct(); });
    } else {
      syncSetLabel();
      syncSwatchLinks();
      watchMainProduct();
    }
  })();


  (function() {
    if (window.__mkColorSwapInit) return;
    window.__mkColorSwapInit = true;

    // Précharge les 8 sections frères en tâche de fond après le load (idle, non-bloquant).
    // Mets à false pour ne garder QUE le prefetch au survol/touch (≈ zéro octet superflu).
    var PREFETCH_ALL = true;

    // FIX RETOUR NAVIGATEUR (2026-07-16) — vrai si un swap couleur a eu lieu dans CETTE page.
    // Voir le listener popstate plus bas : on ne peut pas se fier au state de l'entree d'arrivee.
    var mkSwapped = false;
    var cache = new Map();  // fetchUrl -> Promise<string html>
    var inflight = null;    // AbortController du swap réseau en cours (cache-miss)
    var latest = null;      // dernière URL demandée (last-click-wins)

    // NB : on n'utilise PAS requestIdleCallback — sur cette PDP saturée de JS tiers les périodes
    // idle sont rares et le prefetch traînerait (mesuré). setTimeout garantit sa progression sans
    // bloquer (fetch réseau = hors fil principal ; parse/insert d'une section ≈ 65 ms seulement).
    var schedule = function(fn){ setTimeout(fn, 250); };

    function sectionIdFrom(el) {
      var root = el.closest ? el.closest('.shopify-section') : null;
      return (root && root.id) ? root.id.replace(/^shopify-section-/, '') : null;
    }
    function target(a) {
      var href = a.getAttribute('href'); if (!href) return null;
      var sid = sectionIdFrom(a); if (!sid) return null;
      var sep = href.indexOf('?') > -1 ? '&' : '?';
      return { href: href, url: href + sep + 'section_id=' + encodeURIComponent(sid) };
    }

    // Cache mémoire : lance (une seule fois) le fetch d'une section et stocke la promesse.
    function warm(url) {
      if (cache.has(url)) return cache.get(url);
      var p = fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .catch(function(e){ cache.delete(url); throw e; }); // ne jamais cacher un échec
      cache.set(url, p);
      return p;
    }
    function prefetch(a) {
      if (!a || a.classList.contains('cross-product-swatch--selected')) return;
      var t = target(a); if (t) warm(t.url).catch(function(){});
    }
    function prefetchAll() {
      if (!PREFETCH_ALL) return;
      var list = [].slice.call(document.querySelectorAll('.cross-product-swatch'));
      var i = 0;
      (function next(){
        if (i >= list.length) return;
        prefetch(list[i++]);
        schedule(next); // un par tick idle → pas de rafale de 8 requêtes
      })();
    }

    function setLoading(root, on) {
      if (!root) return;
      if (on) {
        root.style.transition = 'opacity .15s ease';
        root.style.opacity = '0.5';
        root.style.pointerEvents = 'none';
        root.setAttribute('aria-busy', 'true');
      } else {
        root.style.opacity = '';
        root.style.pointerEvents = '';
        root.removeAttribute('aria-busy');
      }
    }

    function applyHtml(root, href, html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById(root.id) || doc.querySelector('.shopify-section');
      if (!fresh) throw new Error('section introuvable');

      // Le sélecteur véhicule LIVE est conservé tel quel (même noeud → handlers + état "véhicule
      // confirmé" intacts). On garde la référence, on le ré-insère après le rendu.
      var liveVfit = root.querySelector('#mkvfit-wrap');

      // Rendu via innerHTML sur root (élément CONNECTÉ) : les custom elements (<variant-picker>…)
      // s'upgradent ET se connectent nativement, exactement comme au 1er chargement de page.
      // On NE déplace PAS les noeuds custom element depuis un doc DOMParser (registre absent) — ça
      // laissait le <variant-picker> natif cassé (selectCombination throw + couverture figée : le
      // prix/variant ne se mettaient plus à jour après un swap).
      root.innerHTML = fresh.innerHTML;

      // Ré-insérer le noeud véhicule live à la place de la version fraîche (préserve tout son état).
      var freshVfit = root.querySelector('#mkvfit-wrap');
      if (liveVfit && freshVfit) freshVfit.replaceWith(liveVfit);

      setLoading(root, false);
      try { window.history.pushState({ mkColor: true }, '', href); mkSwapped = true; } catch (e) {}
      if (typeof window.mkReinitUnifiedCart === 'function') window.mkReinitUnifiedCart();

      // Recaler l'état du bouton ATC : vehicle-fit écoute 'variant:changed' (délégué).
      // NB : on NE dispatch PAS de 'change' sur input[name=id] ni sur les radios option2 — ça
      // réveille le <variant-picker> natif de theme.js (selectCombination) qui THROW en contexte
      // cross-produit. La section fraîche est déjà rendue par le serveur avec le bon variant/prix/
      // couverture (le href cliqué encode la couverture via data-mkcov).
      document.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true }));

      // Re-synchroniser les href couleur sur la couverture courante SANS event (réplique
      // syncSwatchLinks) : préserve la couverture aux swaps suivants + garde les clés de cache
      // cohérentes. Aucun dispatch → aucun réveil du variant-picker natif.
      try {
        var covChk = root.querySelector('.variant-set-card input[type="radio"][name$="-option2"]:checked');
        var covCard = covChk && covChk.closest('.variant-set-card');
        var covT = covCard && covCard.querySelector('.variant-set-card__title');
        var cov = covT ? covT.textContent.trim() : '';
        var sws = root.querySelectorAll('.cross-product-swatch');
        for (var k = 0; k < sws.length; k++) {
          var s = sws[k], b = s.getAttribute('data-base-href') || s.getAttribute('href');
          if (!b) continue;
          var mp = {}; try { mp = JSON.parse(s.getAttribute('data-mkcov') || '{}'); } catch (e) {}
          s.setAttribute('href', (cov && mp[cov]) ? mp[cov] : b);
        }
      } catch (e) {}

      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      }
      schedule(prefetchAll); // réchauffe les frères de la nouvelle couleur pour le prochain swap
    }

    function doSwap(a) {
      var t = target(a);
      var root = a.closest ? a.closest('.shopify-section') : null;
      if (!t || !root || !root.id) { window.location.href = a.getAttribute('href'); return; }

      latest = t.url;
      // État de chargement posé tout de suite. Si la section est déjà en cache ET résolue
      // (préchargée), le .then s'exécute en microtâche AVANT le prochain paint → AUCUN flash.
      // Si cache-miss / prefetch encore en vol → l'opacité 0.5 reste visible pendant l'attente.
      setLoading(root, true);

      if (!cache.has(t.url)) {
        if (inflight) { try { inflight.abort(); } catch (e) {} }
        var ctrl = ('AbortController' in window) ? new AbortController() : null;
        inflight = ctrl;
        var p = fetch(t.url, { signal: ctrl ? ctrl.signal : undefined, headers: { 'X-Requested-With': 'fetch' } })
          .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .catch(function(e){ cache.delete(t.url); throw e; });
        cache.set(t.url, p);
      }

      cache.get(t.url)
        .then(function(html){
          if (t.url !== latest) return;         // supplanté par un clic plus récent
          applyHtml(root, t.href, html);
        })
        .catch(function(err){
          if (err && err.name === 'AbortError') return;
          cache.delete(t.url);
          if (t.url === latest) window.location.href = t.href; // repli navigation normale
        });
    }

    // Prefetch d'intention : au survol (desktop, pointerover bubbles) / début de touch (mobile).
    document.addEventListener('pointerover', function(e){
      var a = e.target && e.target.closest ? e.target.closest('.cross-product-swatch') : null;
      if (a) prefetch(a);
    });
    document.addEventListener('touchstart', function(e){
      var a = e.target && e.target.closest ? e.target.closest('.cross-product-swatch') : null;
      if (a) prefetch(a);
    }, { passive: true });

    document.addEventListener('click', function(e) {
      var a = e.target && e.target.closest ? e.target.closest('.cross-product-swatch') : null;
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return; // nouvel onglet / clic milieu
      e.preventDefault();
      if (a.classList.contains('cross-product-swatch--selected')) return;
      doSwap(a);
    });

    // back/forward après un swap → rechargement réel (simple et fiable)
    //
    // FIX 2026-07-16 — l'ancienne garde `if (e.state && e.state.mkColor)` ne testait QUE
    // l'entrée d'ARRIVÉE. Or popstate reçoit le state de la page vers laquelle on revient :
    //   - retour vers la page d'origine (tapis/coffre) : state = null
    //   - retour vers l'origine (housses) : state = {"path":"…"} (posé par le variant-picker
    //     natif du thème, pas par le swap)
    // Dans les deux cas `mkColor` est absent → aucun rechargement → l'URL redevenait
    // …-all-black pendant que la page affichait encore Ferrari Red (H1, images, variant).
    // Le bouton Retour semblait mort. Reproduit en live sur les 3 familles (10 templates).
    // Le retour ENTRE deux swaps fonctionnait, lui (l'arrivée portait bien {mkColor:true}).
    //
    // On se fie donc à un drapeau de session : dès qu'un swap a eu lieu dans cette page, le DOM
    // ne correspond plus à l'URL d'origine → tout popstate impose un rechargement réel.
    // Sans swap, `mkSwapped` reste faux : on ne touche PAS à la navigation native du thème
    // (ex. retour sur un simple changement de couverture).
    window.addEventListener('popstate', function(e) {
      if (mkSwapped || (e.state && e.state.mkColor)) window.location.reload();
    });

    // Préchargement de fond des 8 frères une fois la page prête (idle).
    if (document.readyState === 'complete') schedule(prefetchAll);
    else window.addEventListener('load', function(){ schedule(prefetchAll); });
  })();


(function(){
  if (window.__mkcovInit) return; window.__mkcovInit = true;
  if (!(window.MK_VP && window.MK_VP.isMat)) return; // popover couverture : car mats seulement
  function closePop(pop){ if(!pop) return; pop.hidden = true; var b = pop.parentNode && pop.parentNode.querySelector('.mkcov-info'); if(b) b.setAttribute('aria-expanded','false'); }
  document.addEventListener('click', function(e){
    var info = e.target.closest ? e.target.closest('.mkcov-info') : null;
    if (info){
      e.preventDefault();
      var pop = info.parentNode.querySelector('.mkcov-pop');
      var willOpen = pop && pop.hidden;
      document.querySelectorAll('.mkcov-pop:not([hidden])').forEach(function(p){ if(p!==pop) closePop(p); });
      if (pop){ pop.hidden = !willOpen; info.setAttribute('aria-expanded', willOpen ? 'true' : 'false'); }
      return;
    }
    if (e.target.closest && e.target.closest('.mkcov-close')){ closePop(e.target.closest('.mkcov-pop')); return; }
    if (e.target.closest && e.target.closest('.mkcov-pop')) return;
    document.querySelectorAll('.mkcov-pop:not([hidden])').forEach(closePop);
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') document.querySelectorAll('.mkcov-pop:not([hidden])').forEach(closePop); });
})();

